module.exports = __webpack_public_path__ + "logo-orkla-blue-999ed7182c0c8bccbaa3997938a4df58.svg";


//////////////////
// WEBPACK FOOTER
// ./Resources/public/static-src/images/logo-orkla-blue.svg
// module id = 2
// module chunks = 0